import DataSourceConfig from '../Config/DataSourceConfig';
import SystemDataService from '../Services/SystemDataService';
import { BlogEntity } from '../Entities';

// NOTE: keep everything above the first `export` free of Entity references, // scripts/seed-content-to-s3.js evaluates that part in a sandbox (with ASSETS
// provided) to extract LOCAL_BLOGS. Image fields reference ASSETS[KEY] so they
// resolve to a real URL both here (local render) and in the seed script.
const LOCAL_BLOGS = [
    {
        "id": "guide-close-open-or-expired-permit",
        "status": true,
        "slug": "guide-one",
        "language": "en",
        "category": "Category One",
        "readTime": 7,
        "generatedAt": "2026-08-04T09:00:00.000Z",
        "publishedAt": "2026-08-04T09:00:00.000Z",
        "updatedAt": "2026-08-04T09:00:00.000Z",
        "title": "Headline goes here",
        "subtitle": "Add your subtitle here. This placeholder describes the article.",
        "hook": "HOOK\nTEXT?",
        "image": '/placeholder.svg',
        "cardImage": '/placeholder.svg',
        "heroImage": '/placeholder.svg',
        "seo": {
            "title": "Headline goes here",
            "description": "Add your SEO description here. This placeholder can be replaced with your own copy.",
            "keywords": ["keyword one", "keyword two", "keyword three", "keyword four", "keyword five", "keyword six"],
            "image": '/placeholder.svg'
        },
        "tldr": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
        "keyTakeaways": [
            "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
            "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
            "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
            "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
            "Add your content here. This placeholder describes the section and can be replaced with your own copy."
        ],
        "intro": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
        "sections": [
            {
                "heading": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                "bullets": [
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy."
                ],
                "image": '/placeholder.svg'
            },
            {
                "heading": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                "bullets": [
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy."
                ]
            },
            {
                "heading": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy."
            },
            {
                "heading": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy."
            },
            {
                "heading": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                "bullets": [
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy."
                ]
            },
            {
                "heading": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy."
            }
        ],
        "conclusion": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
        "faqList": [
            { "question": "Frequently asked question?", "answer": "Answer goes here." },
            { "question": "Frequently asked question?", "answer": "Answer goes here." },
            { "question": "Frequently asked question?", "answer": "Answer goes here." },
            { "question": "Frequently asked question?", "answer": "Answer goes here." }
        ],
        "tags": ["Tag One", "Tag Two", "Tag Three", "Tag Four"]
    },
    {
        "id": "guide-code-violation-notice",
        "status": true,
        "slug": "guide-two",
        "language": "en",
        "category": "Category Two",
        "readTime": 6,
        "generatedAt": "2026-08-05T09:00:00.000Z",
        "publishedAt": "2026-08-05T09:00:00.000Z",
        "updatedAt": "2026-08-05T09:00:00.000Z",
        "title": "Headline goes here",
        "subtitle": "Add your subtitle here. This placeholder describes the article.",
        "hook": "HOOK\nTEXT?",
        "image": '/placeholder.svg',
        "cardImage": '/placeholder.svg',
        "heroImage": '/placeholder.svg',
        "seo": {
            "title": "Headline goes here",
            "description": "Add your SEO description here. This placeholder can be replaced with your own copy.",
            "keywords": ["keyword one", "keyword two", "keyword three", "keyword four", "keyword five", "keyword six", "keyword seven"],
            "image": '/placeholder.svg'
        },
        "tldr": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
        "keyTakeaways": [
            "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
            "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
            "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
            "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
            "Add your content here. This placeholder describes the section and can be replaced with your own copy."
        ],
        "intro": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
        "sections": [
            {
                "heading": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                "bullets": [
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy."
                ]
            },
            {
                "heading": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                "image": '/placeholder.svg'
            },
            {
                "heading": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy."
            },
            {
                "heading": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy."
            },
            {
                "heading": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy."
            }
        ],
        "conclusion": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
        "faqList": [
            { "question": "Frequently asked question?", "answer": "Answer goes here." },
            { "question": "Frequently asked question?", "answer": "Answer goes here." },
            { "question": "Frequently asked question?", "answer": "Answer goes here." },
            { "question": "Frequently asked question?", "answer": "Answer goes here." }
        ],
        "tags": ["Tag One", "Tag Two", "Tag Three", "Tag Four"]
    },
    {
        "id": "guide-resolve-stop-work-order",
        "status": true,
        "slug": "guide-three",
        "language": "en",
        "category": "Category Three",
        "readTime": 6,
        "generatedAt": "2026-08-06T09:00:00.000Z",
        "publishedAt": "2026-08-06T09:00:00.000Z",
        "updatedAt": "2026-08-06T09:00:00.000Z",
        "title": "Headline goes here",
        "subtitle": "Add your subtitle here. This placeholder describes the article.",
        "hook": "HOOK\nTEXT?",
        "image": '/placeholder.svg',
        "cardImage": '/placeholder.svg',
        "heroImage": '/placeholder.svg',
        "seo": {
            "title": "Headline goes here",
            "description": "Add your SEO description here. This placeholder can be replaced with your own copy.",
            "keywords": ["keyword one", "keyword two", "keyword three", "keyword four", "keyword five", "keyword six"],
            "image": '/placeholder.svg'
        },
        "tldr": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
        "keyTakeaways": [
            "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
            "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
            "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
            "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
            "Add your content here. This placeholder describes the section and can be replaced with your own copy."
        ],
        "intro": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
        "sections": [
            {
                "heading": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                "bullets": [
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy."
                ],
                "image": '/placeholder.svg'
            },
            {
                "heading": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy."
            },
            {
                "heading": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy."
            },
            {
                "heading": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                "bullets": [
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy."
                ]
            },
            {
                "heading": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy."
            }
        ],
        "conclusion": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
        "faqList": [
            { "question": "Frequently asked question?", "answer": "Answer goes here." },
            { "question": "Frequently asked question?", "answer": "Answer goes here." },
            { "question": "Frequently asked question?", "answer": "Answer goes here." },
            { "question": "Frequently asked question?", "answer": "Answer goes here." }
        ],
        "tags": ["Tag One", "Tag Two", "Tag Three", "Tag Four"]
    },
    {
        "id": "guide-home-with-open-permits",
        "status": true,
        "slug": "guide-four",
        "language": "en",
        "category": "Category Four",
        "readTime": 7,
        "generatedAt": "2026-08-07T09:00:00.000Z",
        "publishedAt": "2026-08-07T09:00:00.000Z",
        "updatedAt": "2026-08-07T09:00:00.000Z",
        "title": "Headline goes here",
        "subtitle": "Add your subtitle here. This placeholder describes the article.",
        "hook": "HOOK\nTEXT?",
        "image": '/placeholder.svg',
        "heroImage": '/placeholder.svg',
        "seo": {
            "title": "Headline goes here",
            "description": "Add your SEO description here. This placeholder can be replaced with your own copy.",
            "keywords": ["keyword one", "keyword two", "keyword three", "keyword four", "keyword five", "keyword six", "keyword seven"],
            "image": '/placeholder.svg'
        },
        "tldr": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
        "keyTakeaways": [
            "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
            "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
            "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
            "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
            "Add your content here. This placeholder describes the section and can be replaced with your own copy."
        ],
        "intro": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
        "sections": [
            {
                "heading": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                "bullets": [
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy."
                ]
            },
            {
                "heading": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                "bullets": [
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy."
                ],
                "image": '/placeholder.svg'
            },
            {
                "heading": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                "bullets": [
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy."
                ]
            },
            {
                "heading": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy."
            }
        ],
        "conclusion": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
        "faqList": [
            { "question": "Frequently asked question?", "answer": "Answer goes here." },
            { "question": "Frequently asked question?", "answer": "Answer goes here." },
            { "question": "Frequently asked question?", "answer": "Answer goes here." },
            { "question": "Frequently asked question?", "answer": "Answer goes here." }
        ],
        "tags": ["Tag One", "Tag Two", "Tag Three", "Tag Four"]
    },
    {
        "id": "guide-legalize-unpermitted-work",
        "status": true,
        "slug": "guide-five",
        "language": "en",
        "category": "Category One",
        "readTime": 8,
        "generatedAt": "2026-08-08T09:00:00.000Z",
        "publishedAt": "2026-08-08T09:00:00.000Z",
        "updatedAt": "2026-08-08T09:00:00.000Z",
        "title": "Headline goes here",
        "subtitle": "Add your subtitle here. This placeholder describes the article.",
        "hook": "HOOK\nTEXT?",
        "image": '/placeholder.svg',
        "heroImage": '/placeholder.svg',
        "seo": {
            "title": "Headline goes here",
            "description": "Add your SEO description here. This placeholder can be replaced with your own copy.",
            "keywords": ["keyword one", "keyword two", "keyword three", "keyword four", "keyword five", "keyword six"],
            "image": '/placeholder.svg'
        },
        "tldr": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
        "keyTakeaways": [
            "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
            "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
            "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
            "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
            "Add your content here. This placeholder describes the section and can be replaced with your own copy."
        ],
        "intro": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
        "sections": [
            {
                "heading": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                "bullets": [
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy."
                ],
                "image": '/placeholder.svg'
            },
            {
                "heading": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy."
            },
            {
                "heading": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy."
            },
            {
                "heading": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy."
            },
            {
                "heading": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                "bullets": [
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy."
                ]
            },
            {
                "heading": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy."
            }
        ],
        "conclusion": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
        "faqList": [
            { "question": "Frequently asked question?", "answer": "Answer goes here." },
            { "question": "Frequently asked question?", "answer": "Answer goes here." },
            { "question": "Frequently asked question?", "answer": "Answer goes here." },
            { "question": "Frequently asked question?", "answer": "Answer goes here." }
        ],
        "tags": ["Tag One", "Tag Two", "Tag Three", "Tag Four"]
    },
    {
        "id": "guide-commercial-permit-due-diligence",
        "status": true,
        "slug": "guide-six",
        "language": "en",
        "category": "Category Four",
        "readTime": 7,
        "generatedAt": "2026-08-09T09:00:00.000Z",
        "publishedAt": "2026-08-09T09:00:00.000Z",
        "updatedAt": "2026-08-09T09:00:00.000Z",
        "title": "Headline goes here",
        "subtitle": "Add your subtitle here. This placeholder describes the article.",
        "hook": "HOOK\nTEXT?",
        "image": '/placeholder.svg',
        "heroImage": '/placeholder.svg',
        "seo": {
            "title": "Headline goes here",
            "description": "Add your SEO description here. This placeholder can be replaced with your own copy.",
            "keywords": ["keyword one", "keyword two", "keyword three", "keyword four", "keyword five", "keyword six", "keyword seven"],
            "image": '/placeholder.svg'
        },
        "tldr": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
        "keyTakeaways": [
            "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
            "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
            "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
            "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
            "Add your content here. This placeholder describes the section and can be replaced with your own copy."
        ],
        "intro": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
        "sections": [
            {
                "heading": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                "bullets": [
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy."
                ],
                "image": '/placeholder.svg'
            },
            {
                "heading": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                "bullets": [
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
                    "Add your content here. This placeholder describes the section and can be replaced with your own copy."
                ]
            },
            {
                "heading": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy."
            },
            {
                "heading": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy."
            },
            {
                "heading": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy."
            }
        ],
        "conclusion": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
        "faqList": [
            { "question": "Frequently asked question?", "answer": "Answer goes here." },
            { "question": "Frequently asked question?", "answer": "Answer goes here." },
            { "question": "Frequently asked question?", "answer": "Answer goes here." },
            { "question": "Frequently asked question?", "answer": "Answer goes here." }
        ],
        "tags": ["Tag One", "Tag Two", "Tag Three", "Tag Four"]
    }
];

// Normalization / active-filter live on BlogEntity.
export const getBlogsData = async () => {
    const localBlogs = BlogEntity.list(LOCAL_BLOGS);

    if (DataSourceConfig.blogs === 'local') return localBlogs;

    try {
        const data = await SystemDataService.getBlogsData();

        return Array.isArray(data) && data.length > 0
            ? BlogEntity.list(data)
            : localBlogs;
    } catch (_) {
        return localBlogs;
    }
};

export const getBlogBySlug = async (slug) => {
    const localBlog = BlogEntity.list(LOCAL_BLOGS).find((b) => b.slug === slug) || null;

    if (DataSourceConfig.blogs === 'local') return localBlog;

    try {
        const data = await SystemDataService.getBlogBySlug(slug);

        if (data && !Array.isArray(data)) {
            return BlogEntity.isActiveRaw(data) ? BlogEntity.from(data) : localBlog;
        }

        if (Array.isArray(data) && data.length > 0) {
            return BlogEntity.list(data)[0] || localBlog;
        }

        return localBlog;
    } catch (_) {
        return localBlog;
    }
};
